import {
CalledDest
} from 'one-state-calldest/src/CalledDest';

/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * Calling Destination Model
 * @param response has the backend
 * calling destination response
 * @param context has settings etc...
 */
export const TransformResponse = (response: any, context: any)=> {
    /**
     * @param result contains the transformed response
     */
    const { log } = context;
    let note = "";
    let nexttime="";
    const days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    const monthNames = ["January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"];
    //To find the current time
    const currentdate = new Date();
    const currentday = days[currentdate.getDay()];
    const hour = (currentdate.getHours() < 10 ? "0" + currentdate.getHours() : currentdate.getHours());
    const minute = (currentdate.getMinutes() < 10 ? "0" + currentdate.getMinutes() : currentdate.getMinutes());
    const currenttime = (hour + ":" + minute).toString();
    // To get the next date 
    const nextdate = new Date(currentdate);
    nextdate.setDate(nextdate.getDate() + 1)
    const nextday = days[nextdate.getDay()];
    const day = nextdate.getDate();
    //const month = nextdate.getMonth() + 1;
    const monthdata = monthNames[nextdate.getMonth()]
    const year = nextdate.getFullYear();
    //const date = day + "-" + month + "-" + year;
    let calldest: CalledDest = {
          calledname: "",
          calledphone: "",
          calledaddress:"",
          calledtype:"",
          hoursoperation:{
          }
    };

    let result: any = {
        calldest: calldest,
        error: undefined

    }
    log.debug("on-epic", "transformation entered", response);
    // TODO:verify backend team check for errors
    if (response && (response.status >= 400 || response.type == "error")) {
        result.error = response;
    }
     if(response?.days) {
         //todo: Create data from interface
            let mon_start="",mon_end = "",
            tue_start="",tue_end="",
            wed_start="",wed_end="",
            thur_start="",thur_end="",
            fri_start="",fri_end="",
            sat_start ="", sat_end="",
            sun_start="",sun_end="";
        let data: any = {}
        response.days.map((daysdata: any)=>{
            if(daysdata?.name?.toLowerCase() === "monday") {
                mon_start = daysdata.openTime?daysdata.openTime:"";
                mon_end = daysdata.closeTime?daysdata.closeTime:"";
            } else if(daysdata?.name?.toLowerCase() === "tuesday") {
                tue_start = daysdata.openTime?daysdata.openTime:"";
                tue_end = daysdata.closeTime?daysdata.closeTime:"";
            } else if(daysdata?.name?.toLowerCase() === "wednesday") {
                wed_start = daysdata.openTime?daysdata.openTime:"";
                wed_end = daysdata.closeTime?daysdata.closeTime:"";
            } else if(daysdata?.name?.toLowerCase() === "thursday") {
                thur_start = daysdata.openTime?daysdata.openTime:"";
                thur_end = daysdata.closeTime?daysdata.closeTime:"";
            } else if(daysdata?.name?.toLowerCase() === "friday") {
                fri_start = daysdata.openTime?daysdata.openTime:"";
                fri_end = daysdata.closeTime?daysdata.closeTime:"";
            } else if(daysdata?.name?.toLowerCase() === "saturday") {
                sat_start = daysdata.openTime?daysdata.openTime:"";
                sat_end = daysdata.closeTime?daysdata.closeTime:"";
            } else if(daysdata?.name?.toLowerCase() === "sunday") {
                sun_start= daysdata.openTime?daysdata.openTime:"";
                sun_end = daysdata.closeTime?daysdata.closeTime:"";
            }
            //To find the next days open time
            if(nextday === daysdata.name) {
                nexttime = daysdata.openTime;
            }
        });
        response.days.forEach((timedata: any) => {
            //To compare day and Time of call
            if(currentday === timedata.name) {
                //If the patient calls during working hours
                if((currenttime < timedata.closeTime) && (currenttime > timedata.openTime) ) {
                    note = `The location is open now, and will close at ${timedata.closeTime} today.`;
                }
                //If patient calls after working hours
                else if(currenttime > timedata.closeTime) {
                  note = `The location is closed now, and will reopen on ${nextday} ${monthdata}  ${day}th, ${year} at ${nexttime} Central Standard Time.`;
                }
                //If patient calls before working hours
                else if(currenttime < timedata.openTime )
                {
                    note = `The location is closed now, and will open at ${timedata.openTime} today.`;
                }
            }
        });
        data = {
            monday_start: mon_start, monday_end: mon_end,
            tuesday_start: tue_start, tuesday_end: tue_end,
            wednesday_start: wed_start, wednesday_end: wed_end,
            thursday_start: thur_start, thursday_end: thur_end,
            friday_start: fri_start, friday_end: fri_end,
            saturday_start:sat_start,saturday_end:sat_end,
            sunday_start: sun_start, sunday_end: sun_end
        }
        calldest.calledname = response.pharmacyName ? response.pharmacyName : "";
        calldest.calledphone = response.Phone ? response.Phone : "";
        calldest.calledaddress = response.Address?response.Address:"" || response.address ? response.address :"";
        calldest.calledtype = response.typeName? response.typeName:"";
        calldest.hoursoperation = data;
        calldest.note = note;
    }

    result.calldest=calldest;
    log.debug(
        "ccw-gadget,callingdestination-epic",
        "callingdestination-epic transforamtion response ", {
        result
    });
    return result;
}